import { ColorModeScript } from '@chakra-ui/react';
import React, { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorker from './serviceWorker';

const rootElement = document.getElementById('root');

createRoot(rootElement).render(
  <StrictMode>
    <ColorModeScript />
    <App />
  </StrictMode>
);

serviceWorker.unregister();

reportWebVitals();
